import { createSelector } from "reselect"
import { capitalize } from "lodash"
import { getFactorCategoryName } from "./items"
import { getStartDate, getEndDate } from "./dates"

const getPositionSetName = (_, props) => props.positionSetName
const getViewType = (_, props) => props.viewType

export const getFileName = createSelector(
  [getPositionSetName, getViewType, getStartDate, getEndDate, getFactorCategoryName],
  (positionSetName, viewType, startDate, endDate, factorCategoryName) => `${positionSetName} ${capitalize(viewType)} ${factorCategoryName} ${startDate} - ${endDate}`,
)
